/**
 * QrBounce — tiny page at /q/:slug that fires a scan-track event to the
 * backend then redirects to /book/:slug. Every printed QR encodes /q/:slug
 * (not /book/:slug directly) so we can build an analytics dashboard.
 */
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function QrBounce() {
  const { slug } = useParams();
  useEffect(() => {
    // Best-effort track — never blocks the redirect.
    axios
      .post(`${BASE}/api/qr/track/${slug}`, {}, { timeout: 3000 })
      .catch(() => {})
      .finally(() => {
        window.location.replace(`/book/${slug}`);
      });
  }, [slug]);
  return (
    <div className="min-h-screen bg-[#F6F5F1] grid place-items-center text-ink-mid">
      <div className="text-center">
        <Loader2 className="w-6 h-6 animate-spin mx-auto mb-3" />
        <div className="text-sm">Opening booking page…</div>
      </div>
    </div>
  );
}
